import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../context/LanguageContext";
import { ReactComponent as GermanFlag } from "../assets/komet-assets/GermanFlag.svg";
import culture from "../assets/komet-assets/culture.svg";
import writingSkills from "../assets/komet-assets/writingSkills.svg";
import award from "../assets/komet-assets/award.png";
import speach from "../assets/komet-assets/speach.svg";

const AboutUs = () => {
    const { language } = useLanguage();

    const content = {
        SectionHeaderTitle: {
            en: "About Komet Institut",
            ar: "حول معهد كوميت",
            de: "Über das Komet Institut",
        },
        sections: {
            en: [
                {
                    title: "Our Mission",
                    content:
                        "At Komet Institut, we are committed to providing high-quality German language education. Our native-speaking instructors and modern teaching methods ensure an immersive learning experience.",
                },
                {
                    title: "Why Choose Us?",
                    content:
                        "Komet Institut is more than just a language school; we introduce our students to German culture, traditions, and real-life communication skills that go beyond the classroom.",
                },
            ],
            ar: [
                {
                    title: "مهمتنا",
                    content:
                        "في معهد كوميت، نحن ملتزمون بتقديم تعليم عالي الجودة باعتبارنا فريقًا يتحدث اللغة الألمانية كلغة أم، فقد حددنا لأنفسنا هدفًا يتمثل في تقديم المساعدة اللغوية لأولئك الذين يرغبون في إتقان اللغة الألمانية ومساعدتهم على إلقاء نظرة فاحصة على الثقافة الألمانية.",
                },
                {
                    title: "لماذا نحن؟",
                    content:
                        "كوميت ليس مجرد معهد لغة، بل نُعرّف طلابنا على الثقافة الألمانية والتقاليد ومهارات التواصل الحقيقية التي تتجاوز الفصول الدراسية.",
                },
            ],
            de: [
                {
                    title: "Unsere Mission",
                    content:
                        "Am Komet Institut engagieren wir uns für eine hochwertige Deutschsprachenausbildung. Unsere muttersprachlichen Lehrkräfte und modernen Lehrmethoden bieten ein immersives Lernerlebnis.",
                },
                {
                    title: "Warum uns wählen?",
                    content:
                        "Das Komet Institut ist mehr als nur eine Sprachschule; wir bringen unseren Schülern die deutsche Kultur, Traditionen und lebensnahe Kommunikationsfähigkeiten bei, die über das Klassenzimmer hinausgehen.",
                },
            ],
        },
        additionalSection: {
            en: [
                {
                    icon: <img src={speach} alt="speach" className="w-12 h-12" />,
                    title: "Enhancing German conversation skills.",
                },
                {
                    icon: <img src={award} alt="award" className="w-12 h-12" />,
                    title: "Qualifying students to pass certified examination.",
                },
                {
                    icon: <img src={writingSkills} alt="writingSkills" className="w-12 h-12" />,
                    title: "Allow spoken and written German language to flourish.",
                },
                {
                    icon: <img src={culture} alt="culture" className="w-12 h-12" />,
                    title: "Introducing Egyptian society to the German language and culture.",
                },
            ],
            ar: [
                {
                    icon: <img src={speach} alt="speach" className="w-12 h-12" />,
                    title: "تعزيز مهارات التحدث باللغة الألمانية.",
                },
                {
                    icon: <img src={award} alt="award" className="w-12 h-12" />,
                    title: "تأهيل الطلاب لاجتياز الامتحانات المعتمدة.",
                },
                {
                    icon: <img src={writingSkills} alt="writingSkills" className="w-12 h-12" />,
                    title: "تنمية مهارات التحدث والكتابة باللغة الألمانية.",
                },
                {
                    icon: <img src={culture} alt="culture" className="w-12 h-12" />,
                    title: "تعريف المجتمع المصري باللغة والثقافة الألمانية.",
                },
            ],
            de: [
                {
                    icon: <img src={speach} alt="speach" className="w-12 h-12" />,
                    title: "Verbesserung der deutschen Konversationsfähigkeiten.",
                },
                {
                    icon: <img src={award} alt="award" className="w-12 h-12" />,
                    title: "Qualifizierung der Studierenden für zertifizierte Prüfungen.",
                },
                {
                    icon: <img src={writingSkills} alt="writingSkills" className="w-12 h-12" />,
                    title: "Förderung der gesprochenen und geschriebenen deutschen Sprache.",
                },
                {
                    icon: <img src={culture} alt="culture" className="w-12 h-12" />,
                    title: "Einführung der ägyptischen Gesellschaft in die deutsche Sprache und Kultur.",
                },
            ],
        },
        services: {
            en: [
                {
                    title: "Certified Courses",
                    content:
                        "We offer our students, who seek to be certified native German speakers, a fully integrated German course containing the whole package of German language levels and sublevels.",
                },
                {
                    title: "Consultancy Services",
                    content:
                        "Our main priority is helping you in every possible way! If you are looking for an opportunity to travel abroad or need guidance for your next move, Komet is the perfect place.",
                },
            ],
            ar: [
                {
                    title: "الدورات المعتمدة",
                    content:
                        "نقدم لطلابنا الذين يسعون إلى أن يكونوا ناطقين أصليين باللغة الألمانية دورة ألمانية متكاملة تحتوي على جميع مستويات اللغة الألمانية والمستويات الفرعية.",
                },
                {
                    title: "خدمات الاستشارات",
                    content:
                        "أولويتنا الرئيسية هي مساعدتك بكل الطرق الممكنة! إذا كنت تبحث عن فرصة للسفر إلى الخارج أو تحتاج إلى إرشاد لاتخاذ خطوتك التالية، فإن كوميت هو المكان المثالي لك.",
                },
            ],
            de: [
                {
                    title: "Zertifizierte Kurse",
                    content:
                        "Wir bieten unseren Studierenden, die zertifizierte Muttersprachler der deutschen Sprache werden möchten, einen vollständig integrierten Deutschkurs mit allen Sprachstufen und Unterstufen an.",
                },
                {
                    title: "Beratungsdienste",
                    content:
                        "Unsere oberste Priorität ist es, Ihnen in jeder Hinsicht zu helfen! Wenn Sie eine Möglichkeit suchen, ins Ausland zu reisen oder eine Orientierung für Ihren nächsten Schritt benötigen, ist Komet der perfekte Ort.",
                },
            ],
        },
    };

    return (
        <div
            className={`relative min-h-screen py-20 px-6 lg:px-32 ${
                language !== "ar" ? "font-mont" : ""
            }`}
        >
            <div className="max-w-7xl mx-auto">
                {/* Page Title */}
                <div className="text-center mb-12 relative">
                    <h1 className="text-4xl font-bold text-germanAccentText">
                        {content.SectionHeaderTitle[language]}
                    </h1>
                </div>
                <div className="relative">
                    <div className="absolute w-full -top-14 flex-center-both blur-sm opacity-80">
                        <span className="text-stroke font-extrabold text-[80px] text-transparent">
                            KOMET
                        </span>
                    </div>
                    <div className="grid relative grid-cols-1 md:grid-cols-2 gap-0 border overflow-y-clip border-gray-200 rounded-xl shadow-sm hover:shadow-lg smooth">
                        <GermanFlag className="absolute left-0 -bottom-6 w-16 opacity-65" />

                        {content.sections[language].map((section, index) => (
                            <motion.div
                                key={index}
                                className={`p-8 smooth ${
                                    index % 2 === 0 ? "border-b md:border-b-0 md:border-r" : ""
                                } border-gray-200`}
                            >
                                <div className="flex items-center gap-3 mb-4">
                                    <motion.div
                                        animate={{ opacity: [0, 1, 0] }}
                                        transition={{ repeat: Infinity, duration: 1.2 }}
                                        className="w-3 h-3 rounded-full bg-yellow-500"
                                    />
                                    <h2
                                        className={`text-2xl ${
                                            language === "ar"
                                                ? "font-semibold"
                                                : "font-medium text-xl md:text-2xl font-mont"
                                        } text-germanRed-700`}
                                    >
                                        {section.title}
                                    </h2>
                                </div>

                                <p
                                    className={`leading-relaxed ${
                                        language === "ar"
                                            ? "text-lg font-normal"
                                            : "text-md md:text-lg font-light font-mont"
                                    } text-gray-700`}
                                >
                                    {section.content}
                                </p>
                            </motion.div>
                        ))}
                    </div>
                </div>

                {/* Separator */}
                <div className="w-1/2 mx-auto border-t border-gray-300 my-12 -z-20"></div>

                <div className="relative">
                    <div className="absolute w-full -top-14 flex-center-both blur-sm opacity-80">
                        <span className="text-stroke font-extrabold text-[80px] text-transparent">
                            INSTITUT
                        </span>
                    </div>
                    <div className="grid grid-cols-1 relative md:grid-cols-2 gap-0 border overflow-y-clip border-gray-200 rounded-xl shadow-sm hover:shadow-lg smooth">
                        <GermanFlag className="absolute left-0 -bottom-6 w-16 opacity-65" />
                        {content.services[language].map((service, index) => (
                            <motion.div
                                key={index}
                                className={`p-8 smooth ${
                                    index % 2 === 0 ? "border-b md:border-b-0 md:border-r" : ""
                                } border-gray-200`}
                            >
                                <div className="flex items-center gap-3 mb-4">
                                    <motion.div
                                        animate={{ opacity: [0, 1, 0] }}
                                        transition={{ repeat: Infinity, duration: 1.2 }}
                                        className="w-3 h-3 rounded-full bg-yellow-500"
                                    />

                                    <h2
                                        className={`${
                                            language === "ar"
                                                ? "text-2xl font-semibold"
                                                : "text-xl md:text-2xl font-medium font-mont"
                                        } text-germanRed-700 mb-2`}
                                    >
                                        {service.title}
                                    </h2>
                                </div>
                                <p
                                    className={`${
                                        language === "ar"
                                            ? "text-lg font-normal"
                                            : "text-md md:text-lg font-light font-mont"
                                    } text-gray-700`}
                                >
                                    {service.content}
                                </p>
                            </motion.div>
                        ))}
                    </div>
                </div>

                {/* Separator */}
                <div className="w-1/2 mx-auto border-t border-gray-300 my-12 -z-20"></div>

                {/* Additional Information Section */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 text-center">
                    {content.additionalSection[language].map((item, index) => (
                        <motion.div
                            key={index}
                            className="border border-yellow-300 rounded-lg p-6 shadow-sm hover:shadow-lg smooth"
                        >
                            <div className="text-5xl flex-center-both">{item.icon}</div>
                            <h3
                                className={`mt-3 ${
                                    language === "ar"
                                        ? "text-xl font-semibold"
                                        : "text-lg font-medium font-mont"
                                } text-germanAccentText`}
                            >
                                {item.title}
                            </h3>
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default AboutUs;
